import React, { useState } from 'react';
import axios from 'axios';
import { API_URLS } from '../../config/api';

const TestFormComponent = () => {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const testAPIConnection = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    
    try {
      const result = await axios.get(API_URLS.test);
      setResponse(result.data);
      console.log('API Test successful:', result.data);
    } catch (err) {
      console.error('API Test failed:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const testFormSubmission = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      const formData = {
        housingType: 'Maison',
        ownerStatus: 'Propriétaire',
        instalationType: 'Pompe a chaleur',
        ageOfHouse: 'Entre 2 ans et 15 ans',
        typeOfEnergy: 'Gaz',
        postalCode: '75001',
        sexe: 'Monsieur',
        firstName: 'Test',
        lastName: 'Utilisateur',
        phone: '0123456789',
        userInfos: JSON.stringify({ test: true, ip: '127.0.0.1' })
      };

      const result = await axios.post(API_URLS.submit, formData);
      setResponse(result.data);
      console.log('Form submission successful:', result.data);
    } catch (err) {
      console.error('Form submission failed:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const testGeoLocation = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      const result = await axios.get("https://ipgeolocation.abstractapi.com/v1/?api_key=ce0de992545c4e1ca8ce4a5aa93abb49");
      setResponse(result.data);
      console.log('Geolocation test successful:', result.data);
    } catch (err) {
      console.error('Geolocation test failed:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Test de Diagnostique du Formulaire</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={testAPIConnection}
          disabled={loading}
          style={{ 
            marginRight: '10px', 
            padding: '10px 15px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Test en cours...' : 'Tester API Connection'}
        </button>
        
        <button 
          onClick={testFormSubmission}
          disabled={loading}
          style={{ 
            marginRight: '10px', 
            padding: '10px 15px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Test en cours...' : 'Tester Soumission Formulaire'}
        </button>

        <button 
          onClick={testGeoLocation}
          disabled={loading}
          style={{ 
            padding: '10px 15px',
            backgroundColor: '#17a2b8',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Test en cours...' : 'Tester Géolocalisation'}
        </button>
      </div>

      {error && (
        <div style={{ 
          padding: '10px', 
          backgroundColor: '#f8d7da', 
          color: '#721c24',
          border: '1px solid #f5c6cb',
          borderRadius: '4px',
          marginBottom: '20px'
        }}>
          <strong>Erreur:</strong> {error}
        </div>
      )}

      {response && (
        <div style={{ 
          padding: '10px', 
          backgroundColor: '#d1ecf1', 
          color: '#0c5460',
          border: '1px solid #bee5eb',
          borderRadius: '4px',
          marginBottom: '20px'
        }}>
          <strong>Réponse:</strong>
          <pre style={{ margin: '10px 0', whiteSpace: 'pre-wrap' }}>
            {JSON.stringify(response, null, 2)}
          </pre>
        </div>
      )}

      <div style={{ marginTop: '30px' }}>
        <h3>Instructions de test:</h3>
        <ol>
          <li>Cliquez sur "Tester API Connection" pour vérifier que l'API répond</li>
          <li>Cliquez sur "Tester Géolocalisation" pour vérifier l'API de géolocalisation</li>
          <li>Cliquez sur "Tester Soumission Formulaire" pour tester l'envoi complet</li>
          <li>Ouvrez les DevTools (F12) pour voir les logs dans la console</li>
          <li>Vérifiez l'onglet Network pour voir les requêtes HTTP</li>
        </ol>
      </div>
    </div>
  );
};

export default TestFormComponent;